/**
 * Evidence Page - ComplyIQ
 *
 * Stub page for managing compliance evidence and artifacts.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { FileCode, Search, Filter, Upload } from 'lucide-react'

export function EvidencePage() {
  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-display font-bold">Evidence</h2>
          <p className="text-muted-foreground">
            Manage evidence artifacts and documentation for compliance controls
          </p>
        </div>
        <Button>
          <Upload className="h-4 w-4 mr-2" />
          Upload Evidence
        </Button>
      </div>

      {/* Filters */}
      <div className="flex gap-4 flex-wrap">
        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Types</option>
          <option value="document">Documents</option>
          <option value="screenshot">Screenshots</option>
          <option value="log">Logs</option>
          <option value="config">Configurations</option>
        </select>

        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search evidence..."
            className="w-full h-10 pl-10 pr-4 rounded-lg border border-border bg-background text-sm"
          />
        </div>

        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          Filters
        </Button>
      </div>

      {/* Evidence Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileCode className="h-5 w-5" />
            Evidence Artifacts
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <FileCode className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="text-lg font-medium">No evidence to display</p>
            <p className="mt-2">
              Evidence artifacts will appear here after they are available from ComplyIQ.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
